import axios from '@/utils/axios'

export const createSalesPrice = (payload ) => {
    return axios.post(`/sales_price_record`, payload)
}

export const getSalesPrice = (payload ) => {
    return axios.get(`/sales_price_record/`, {
        params: payload
    })
}

export const deleteSalesPrice = (id) => {
    return axios.delete(`/sales_price_record/${id}`)
}